import React from 'react'
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import { LogbookPage } from '@BUP/pages/logbook'
import { LogbookShowComplaintPage } from '@BUP/pages/logbook/complaints/show'
import { LogbookNewComplaintPage } from '@BUP/pages/logbook/complaints/new'
import { LogbookShowComplaintEntryPage } from '@BUP/pages/logbook/complaints/entries/show'

const LogbookNavigation = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <RoleRoute
        name='LogbookNewComplaintPage'
        component={LogbookNewComplaintPage}
        path={`${match.path}/complaints/new`}
        exact
      />
      <RoleRoute
        name='LogbookShowComplaintEntryPage'
        component={LogbookShowComplaintEntryPage}
        path={`${match.path}/complaints/:complaintId/entries/:complaintEntryId`}
        exact
      />
      <RoleRoute
        name='LogbookShowComplaintPage'
        component={LogbookShowComplaintPage}
        path={`${match.path}/complaints/:complaintId`}
        exact
      />
      <RoleRoute
        name='LogbookPage'
        component={LogbookPage}
        path={match.path}
        exact
      />
      <Route>
        <Redirect to='/' />
      </Route>
    </Switch>
  )
}

export default LogbookNavigation
